// src/pages/CaseStudy.jsx
import { useState, useEffect } from 'react';

// Import Assets
import campimage1 from '../Assets/CaseStudy/case-study-1.jpg';
import campimage2 from '../Assets/CaseStudy/case-study-2.jpg';
import campimage3 from '../Assets/CaseStudy/case-study-3.jpg';
import campimage4 from '../Assets/CaseStudy/case-study-4.jpg';
import campimage5 from '../Assets/CaseStudy/case-study-5.jpg';
import campimage6 from '../Assets/CaseStudy/case-study-6.jpg';
import campimage7 from '../Assets/CaseStudy/case-study-7.jpg';
import campimage8 from '../Assets/CaseStudy/case-study-8.jpg';
import campimage9 from '../Assets/CaseStudy/case-study-9.jpg';
import campimage10 from '../Assets/CaseStudy/case-study-10.jpg';
import campimage11 from '../Assets/CaseStudy/case-study-11.jpg';
import campimage12 from '../Assets/CaseStudy/case-study-12.jpg';

export default function CaseStudy() {
  // Track the full object (src and caption) for the modal
  const [selectedItem, setSelectedItem] = useState(null);

  const openImage = (item) => setSelectedItem(item);
  const closeImage = () => setSelectedItem(null);

  // Close modal when "Escape" key is pressed
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const videos = [
    {
      title: "Dental Campaign Makes it to Guinness Book World Record",
      embedId: "otAip3ByQWc",
      status: "available",
      description: "Telugu news coverage of the mega dental health check-up that set Guinness record in Vijayawada (21,000+ people screened)",
    },
    {
      title: "Your Dental Camp / Health Initiative Video",
      embedId: "qBEUqtuKEIE",
      status: "available",
      description: "Coverage of our dental outreach program / camp in Vijayawada – inspiring community oral health efforts.",
    },
    {
      title: "Redcross Society Mega Dental Camp Coverage",
      embedId: "KoPphOAbr0A",
      status: "available",
      description: "Watch this powerful coverage of our region's Guinness-recognized mega dental camp by Red Cross Society.",
    },
  ];

  const campImages = [
    { src: campimage1, caption: "Massive community dental screening — empowering thousands of smiles" },
    { src: campimage2, caption: "Large-scale outreach camp — bringing healthy smiles to every child" },
    { src: campimage3, caption: "Community dental health drive — touching lives across Vijayawada" },
    { src: campimage4, caption: "Free screening for hundreds — building brighter futures together" },
    { src: campimage5, caption: "Massive gathering for oral health awareness — empowering communities" },
    { src: campimage6, caption: "School children benefiting from our free dental camps — smiles for all" },
    { src: campimage7, caption: "Village outreach program — delivering care where it's needed most" },
    { src: campimage8, caption: "Thousands screened in one day — our commitment to community health" },
    { src: campimage9, caption: "Empowering rural smiles — free check-ups and education in action" },
    { src: campimage10, caption: "United for oral health — massive camp transforming lives" },
    { src: campimage11, caption: "Bringing hope through dental care — community screening at its best" },
    { src: campimage12, caption: "Reaching every corner — thousands empowered with healthy smiles" },
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-16 px-4 sm:px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        
        {/* Title Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight">
            CASE STUDY
          </h1>
          <div className="mt-4 h-1.5 w-24 bg-blue-700 mx-auto rounded-full" />
          <p className="mt-6 text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Our contribution to community oral health — inspired by landmark events like the Guinness-recognized mega dental camp in Vijayawada.
          </p>
        </div>

        {/* Videos Section */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">
            Video Highlights & Coverage
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map((video, idx) => (
              <div key={idx} className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 flex flex-col hover:shadow-xl transition-shadow duration-300">
                <div className="relative aspect-video bg-black">
                  <iframe
                    width="100%"
                    height="100%"
                    src={`https://www.youtube.com/embed/${video.embedId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">{video.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{video.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Gallery Section */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Glimpses from Dental Health Camps
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
            {campImages.map((item, idx) => (
              <div
                key={idx}
                className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer bg-gray-200 aspect-[4/3]"
                onClick={() => openImage(item)}
              >
                <img
                  src={item.src}
                  alt={item.caption}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay on Hover */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-5">
                  <p className="text-white text-sm font-medium leading-snug transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    {item.caption}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-20 bg-blue-700 rounded-3xl p-10 md:p-16 shadow-2xl">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">Make a Difference with Us</h2>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
            Be part of our mission to promote oral health across Vijayawada and beyond.
          </p>
          <a
            href="/book-appointment"
            className="inline-block bg-white text-blue-700 px-10 py-4 rounded-full font-bold hover:bg-gray-100 transition-all hover:scale-105 shadow-lg"
          >
            Join Our Next Camp →
          </a>
        </div>
      </div>

      {/* ENHANCED IMAGE MODAL */}
      {selectedItem && (
        <div
          className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10 animate-fadeIn"
          onClick={closeImage}
        >
          {/* Close Button - Clean Top Right */}
          <button
            className="absolute top-5 right-5 z-[110] text-white bg-white/10 hover:bg-white/20 w-12 h-12 rounded-full flex items-center justify-center transition-all group"
            onClick={closeImage}
          >
            <span className="text-3xl font-light group-hover:scale-110">×</span>
          </button>

          {/* Image Container */}
          <div 
            className="relative max-w-6xl w-full flex flex-col items-center animate-zoomIn"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedItem.src}
              alt="Enlarged gallery view"
              className="max-h-[85vh] w-auto object-contain rounded-lg shadow-2xl border border-white/5"
            />
            
            {/* Modal Caption */}
            <div className="mt-6 text-center">
              <p className="text-white text-lg md:text-xl font-medium px-4 max-w-3xl">
                {selectedItem.caption}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Adding custom animations via style tag for simplicity */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes zoomIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
        .animate-zoomIn { animation: zoomIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
      `}} />
    </div>
  );
}